import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z","key":"svg-0"}],["path",{"d":"M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z","key":"svg-1"}]]

const IconSquareRoundedLetterB = createReactComponent('outline', 'square-rounded-letter-b', 'SquareRoundedLetterB', __iconNode);

export default IconSquareRoundedLetterB;